module.exports = __webpack_public_path__ + "assets/img/modal-avatar-df61baf5.png";